export default __webpack_public_path__ + "static/media/ninjatransfers-logo.b67c34dc.png";